import $ from 'jquery';
const ScrollMagic = require('scrollmagic');
import screenSize from '../services/screen_size';
// require('../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js');
const controller = new ScrollMagic.Controller();
const $window = $(window);
const scenes = [];

export default ($selector) => {
    if (screenSize.getSize() !== 'small') {
        let $rightRailContainer;
        let $sidebar;
        let $headerAd;
        let $articleContent;
        let $firstAdWrapper, $secondAdWrapper, $thirdAdWrapper, $fourthAdWrapper;
        if ($selector) {
            $rightRailContainer = $selector.find('.sticky-right-rail-container');
            $articleContent = $selector.find('.article-content');
            $sidebar = $selector.find('.article-sidebar');
            $headerAd = $selector.find('.ad-wrapper-large.ad-wrapper-header');
            $firstAdWrapper = $selector.find('.first-ad-wrap')[0];
            $secondAdWrapper = $selector.find('.second-ad-wrap')[0];
            $thirdAdWrapper = $selector.find('.third-ad-wrap')[0];
            $fourthAdWrapper = $selector.find('.fourth-ad-wrap')[0];

        } else {
            $rightRailContainer = $('.sticky-right-rail-container');
            $articleContent = $('.article-content');
            $sidebar = $('.article-sidebar');
            $headerAd = $('.ad-wrapper-large.ad-wrapper-header');
            $firstAdWrapper = $('.first-ad-wrap').last()[0];
            $secondAdWrapper = $('.second-ad-wrap').last()[0];
            $thirdAdWrapper = $('.third-ad-wrap').last()[0];
            $fourthAdWrapper = $('.fourth-ad-wrap').last()[0];
        }

        // Adjust margin for slideshow posts, due to a set height being placed on the slideshow
        const $inlineSlideshowPosterDiv = $sidebar.parent().parent().find('header').last().find('.inline-slideshow');
        const $headerPosterWrapper = $sidebar.parent().parent().find('header').last().find('.poster-wrapper').not('.poster-wrapper__photo-gallery');

        if ($inlineSlideshowPosterDiv.length) {
            // Sometimes slideshows have captions, when that happens, it throws off the height, so we need to adjust them
            const marginTopOnSlideshow = function findOptimalMarginForSlideshowPost() {
                let marginTop = '-533px';
                if ($inlineSlideshowPosterDiv.find('.slideshow-title').length) {
                    marginTop = '-515px';
                    if ($inlineSlideshowPosterDiv.find('.caption-list').length) {
                        marginTop = '-533px';
                    }
                } else if ($inlineSlideshowPosterDiv.find('.slide-list-photogallery').length) {
                    marginTop = '-436px';
                    console.log($inlineSlideshowPosterDiv);
                }
                return marginTop;
            }

            $sidebar.css('margin-top', marginTopOnSlideshow);
        }

        // Adjust margin for article posts, due to a captions set below the header
        if ($headerPosterWrapper.length) {
            // Sometimes posters have captions, when that happens, it throws off the height, so we need to adjust them
            if ($headerPosterWrapper.find('.poster-caption').length) {
                console.log('has poster caption')
	            $sidebar.css('margin-top', '-445px');
            }
        }

        if ($sidebar.parent().parent().find('header').last().find('.-no-art').length) {
            $sidebar.css('margin-top', '-40px');
        }
        // Sometimes the rail shows up before scrollmagic is init, and it creates that flicker effect, so we set sidebar to invis at start and display it via js this way
        $rightRailContainer.fadeIn();

        // If the article is short, we have to use a different duration than the default, otherwise the article page will be extended by the sidebar and thus creating white space at the bottom of article
        const articleContentHeight = $('.post-article').last().outerHeight();
        const articleContentHeightQuartile = articleContentHeight / 8;
        let duration = 1050;

        // For custom post, we have a different sidebar with only one ad:
        // http://www.fastcompany.com/3056002/conquering-the-cloud/progress-by-the-numbers-technology-economics-in-a-digital-world?icid=np204ctc
        if ($('.custom-sidebar-ad-wrap').last().length) {
            const scene1 = new ScrollMagic.Scene({
                triggerElement: $('.custom-sidebar-ad-wrap').last()[0],
                duration: articleContentHeight,
                offset: -50,
                triggerHook: .14
            })
                .setPin($('.custom-sidebar-ad-wrap').last()[0])
                .addTo(controller);
        }

        // The values below have been carefully calibrated for our sidebar behavior
        if ($firstAdWrapper) {
            const scene1 = new ScrollMagic.Scene({
                triggerElement: $firstAdWrapper,
                duration: 850,
                offset: 30,
                triggerHook: .14
            })
                .setPin($firstAdWrapper)
                .addTo(controller);
        }

        if ($secondAdWrapper) {
            const scene2 = new ScrollMagic.Scene({
                triggerElement: $secondAdWrapper,
                duration: duration,
                offset: 30,
                triggerHook: .14
            })
                .setPin($secondAdWrapper)
                .addTo(controller);
        }

        if ($thirdAdWrapper) {
            const scene3 = new ScrollMagic.Scene({
                triggerElement: $thirdAdWrapper,
                duration: duration,
                offset: 30,
                triggerHook: .14
            })
                .setPin($thirdAdWrapper)
                .addTo(controller);
        }

        if ($fourthAdWrapper) {
            const scene4 = new ScrollMagic.Scene({
                triggerElement: $fourthAdWrapper,
                duration: duration,
                offset: 30,
                triggerHook: .2
            })
                .setPin($fourthAdWrapper)
                .addTo(controller);
        }
    }
};
